import { render, staticRenderFns } from "./SysConfigList.vue?vue&type=template&id=cffdb538&xmlns%3Av-bind=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./SysConfigList.vue?vue&type=script&lang=js"
export * from "./SysConfigList.vue?vue&type=script&lang=js"
import style0 from "./SysConfigList.vue?vue&type=style&index=0&id=cffdb538&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports